import React, { Component } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import LookupItemService from '../../../../../Services/LookupItemService';
import ErrorMessage from '../../../../ErrorMessage';
import LoadingIcon from '../../../../LoadingIcon';

export default class LanguageMultiChoice extends Component {
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => alert('LanguageMultiChoice OnChange'),
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    LookupItemService.GetLookupItemListById(20)
      .then((result) => {
        const optValues = [];
        const selected = [];
        result.forEach((language) => {
          const newValue = { label: language.text, value: language.lookupItemId };
          optValues.push(newValue);
          if (this.props.selected?.includes(language.lookupItemId)) {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('LMC56');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected.map((i) => i.value));
  }

  renderList() {
    return (
      <MultiSelect
        className='rmsc'
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={'htmlidfor' + this.props.fieldName}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderList()
          )}
        </div>
      </div>
    );
  }
}
